import * as THREE from 'three'
import { extend } from '@react-three/fiber'

class DofPointsMaterial extends THREE.ShaderMaterial {
  constructor() {
    super({
      vertexShader: `uniform sampler2D positions;
      uniform float uTime;
      uniform float uFocus;
      uniform float uFov;
      uniform float uBlur;
      varying float vDistance;
      void main() { 
        vec3 pos = texture2D(positions, position.xy).xyz;
        vec4 mvPosition = modelViewMatrix * vec4(pos, 1.0);
        gl_Position = projectionMatrix * mvPosition;
        vDistance = abs(uFocus - -mvPosition.z);
        gl_PointSize = (step(1.0 - (1.0 / uFov), position.x)) * vDistance * uBlur * 2.0;
      }`,
      fragmentShader: `uniform float uOpacity;
      uniform float uTime;
      varying float vDistance;
      void main() {
        vec2 cxy = 2.0 * gl_PointCoord - 1.0;
        if (dot(cxy, cxy) > 1.0) discard;
        
        // 基于时间和距离的颜色变化
        float hue = uTime * 0.1 + vDistance * 0.5;
        
        // 定义明亮的颜色组合
        vec3 brightColors[6];
        brightColors[0] = vec3(0.2, 0.8, 1.0);  // 亮青色
        brightColors[1] = vec3(1.0, 0.4, 0.8);  // 亮粉色
        brightColors[2] = vec3(0.8, 1.0, 0.3);  // 亮绿色
        brightColors[3] = vec3(1.0, 0.7, 0.2);  // 亮橙色
        brightColors[4] = vec3(0.6, 0.3, 1.0);  // 亮紫色
        brightColors[5] = vec3(1.0, 1.0, 0.4);  // 亮黄色
        
        // 在亮色之间切换
        float colorIndex = mod(hue * 6.0, 6.0);
        int index1 = int(floor(colorIndex));
        int index2 = int(mod(float(index1 + 1), 6.0));
        float blend = fract(colorIndex);
        
        vec3 color = mix(brightColors[index1], brightColors[index2], blend);
        
        // 添加反光效果
        float distanceFromCenter = length(cxy);
        float highlight = 1.0 - smoothstep(0.0, 0.4, distanceFromCenter);
        highlight = pow(highlight, 6.0); // 让高光非常集中
        
        // 强烈的白色反光
        vec3 reflectionColor = vec3(1.5, 1.5, 1.5); // 超白色
        color = mix(color, reflectionColor, highlight * 0.8); // 更强的反光
        
        float alpha = 1.04 - clamp(vDistance * 1.5, 0.0, 1.0);
        gl_FragColor = vec4(color, alpha);
      }`,
      uniforms: {
        positions: { value: null },
        uTime: { value: 0 },
        uFocus: { value: 5.1 },
        uFov: { value: 50 },
        uBlur: { value: 50 }
      },
      transparent: true,
      blending: THREE.NormalBlending,
      depthWrite: false
    })
  }
}

extend({ DofPointsMaterial })
